import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

Vue.use(Vuex)

import { userGetInfo } from "@/api/user"

export default new Vuex.Store({
  state: {
    token: '' || localStorage.getItem("37aiToken"),
    userInfo: null || JSON.parse(localStorage.getItem("37aiUser")),
  },
  getters: {
    userRole(state) {
      return state.userInfo?.roles?.[0] || { key: 'employee' }
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem("37aiToken", token)
    },
    setUserLogin(state, userInfo) {
      state.userInfo = userInfo
      // 同时储存到localstorage  
      localStorage.setItem("37aiUser", JSON.stringify(userInfo))
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem("37aiUser", JSON.stringify(userInfo))
    },
    clearUserInfo(state) {
      state.userInfo = null;
      state.token = ''
      localStorage.removeItem("37aiUser")
      localStorage.removeItem("37aiToken")
      // router.replace('/login')

    },
  },
  actions: {
    USER_LOGIN({ commit }, userInfo) {
      return new Promise(resolve => {
        commit("setUserLogin", userInfo.user_info);
        commit("setToken", userInfo.token)
        resolve();
      })
    },
    USER_INFO({ commit }) {
      return new Promise((resolve, reject) => {
        userGetInfo().then(res => {
          commit("setUserInfo", res.data);
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    USER_LOGOUT({ commit }) {
      return new Promise(resolve => {
        commit("clearUserInfo")
        resolve();
      })
    }
  },
  modules: {
  }
})
